module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAXUlEQVQ4jWOgFmDEZ86dTLn5DAwMCVDuApXpjxJxqUUx6E6m3HsGBgYBIh35QWX6I0EYh4lqfqMWwBpGdzLl/uMzX2X6Iwx9VPPaqEGjBg0Jgxbg0YNPjkLAwMAAAJ18D1wtaKoaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/ic_btn_delete_press.png
// module id = 733
// module chunks = 0